// extracted by css-extract-rspack-plugin
export default {"editor_table":"vYKS8Iro2swE1Nn6","name_table":"h6nD4JsAiE4SfUos"};